export class OrganisationAttributeChoiceModel {
    public organisationAttributeChoiceId: string
    public organisationAttributeTypeCode: string;
    public organisationAttributeValue: string;
    public organisationAttributeCode: string;
    public organisationAttributeName: string;
    public defaultFlag?: boolean;
    public sortSequence: number;
}